<template>
  <table :class="`shadow-lg table table-responsive-sm ${colWidth? 'tableFixed': ''}`">
    <thead style="background-color: #e2edfc; color: #4a75b5">
        <tr class="text-center">
          <th scope="col" v-if="renderizarCheckBox" :class="'w-5'">
            <slot name="selectAll"></slot>
          </th>
          <th scope="col" :class="'w-5'"></th>
          <th scope="col text-center" v-for="(column, index) in colNames" :class="colWidth ? 'w-'+colWidth[index] : ''" :key="index"> {{column}}</th>
        </tr>
    </thead>
    <tbody :key="keyUpdate.toString()">
        <tr v-for="(item, index) in items" :key="index">
          <td v-if="renderizarCheckBox && item.if !== false">
            <div style="text-align: center;" v-if="disableCheckbox(item)">
              <input type="checkbox" :value="item.data[valueKey]" v-model="keyTableChecked">
            </div>
          </td>
          <td v-if="item.if !== false">
            <i v-if="item.subtable === true" @click.prevent="toggle(index)" :class="item.toggle ? 'pure-button ml-1 fa fa-chevron-right' : 'pure-button ml-1 fa fa-chevron-down'"></i>
            <span v-if="item.subtable === true && !item[0].length" class="ml-1 bg-warning-apensado p-1"></span>
          </td>
          <cell v-for="(column, indexColumn) in getColumn(item)" :length="colNames.length" :key="generateKey(item.if, indexColumn, index)" :column="indexColumn" :data="item" :colWidth="colWidthSubTable">
            <template v-slot="subtable">
              <slot name="subtable" :itemData="subtable.itemData"></slot>
            </template>
          </cell>
          <slot v-if="item.type !== 'subtable'" :itemData="item.data || {}" :more="more"></slot>
        </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="100%">
          <pagination-comp :pagination="pagination" :eventBusDataPaginationName="eventBusDataPaginationName"/>
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import paginationComp from '@/components/pagination/Pagination'
import eventBus from '@/uteis/eventBus'
import { tratarCamposDataTable } from '@/controllers/dataTable'
import cell from '@/components/data-table-consulta/table/cell'

export default {
  components: {
    paginationComp,
    cell
  },

  props: {
    colNames: { required: true, type: Array },
    colWidth: { required: false, type: Array },
    colWidthSubTable: { required: false, type: Array },
    dataTableColumn: { required: false, type: Array, default: () => { return null } },
    renderizarCheckBox: { required: false, type: Boolean, default: false },
    eventBusDataName: { required: true, type: String },
    eventBusDataPaginationName: { required: true, type: String },
    disableCheckbox: { required: false, type: Function, default: () => true },
    valueKey: { required: false, type: String, default: '_id' },
    subtable: { required: false, type: Object }
  },

  data () {
    return {
      items: [],
      column: [],
      more: {},
      pagination: {
        hasPrev: false,
        hasNext: false,
        totalPage: 0,
        prevPages: 0,
        nextPages: 0,
        pageNumber: 1
      },
      keyUpdate: false
    }
  },

  computed: {
    dataTableChecked: {
      get () {
        return this.$store.getters.getDataTableChecked
      }
    },
    keyTableChecked: {
      get () {
        return this.$store.getters.getKeyTableChecked
      },
      set (newValue) {
        const mapChecked = {}
        const checked = []

        for (const id of newValue) {
          mapChecked[id] = true
        }

        for (const value of this.dataTableChecked) {
          if (value.data && mapChecked[value.data[this.valueKey]]) {
            checked.push(value)
            delete mapChecked[value.data[this.valueKey]]
          }
        }

        for (const id of newValue) {
          if (
            mapChecked[id]
          ) {
            const item = this.getItemByValueKey(id)
            if (item) {
              checked.push(item)
            }
            delete mapChecked[id]
          }
        }

        this.$store.commit('MUT_KEY_TABLE_CHECKED', newValue)
        this.$store.commit('MUT_DATA_TABLE_CHECKED', checked)
      }
    }
  },

  methods: {
    getItemByValueKey (id) {
      for (const item of this.items) {
        if (item.data && item.data[this.valueKey] === id) {
          return item
        }
      }
      return []
    },

    getColumn (item) {
      if (item.type === 'subtable') {
        return ['subtable']
      }
      return this.column
    },

    generateKey (hasVisible, index, indexParent) {
      const key = `${(hasVisible !== undefined ? hasVisible.toString() : '')}-${index}-${indexParent}`
      return key
    },

    toggle (index) {
      if (this.items[index + 1].if !== undefined) {
        this.items[index + 1].if = !this.items[index + 1].if
        this.items[index].toggle = !this.items[index].toggle
      }
      this.keyUpdate = !this.keyUpdate
    },

    popularTable (values) {
      this.column = this.dataTableColumn ? this.dataTableColumn : values.dataTableColumn ? values.dataTableColumn : []
      this.items = this.processarDados(values.data)
      this.pagination = values.pagination

      var data = { ...values }
      delete data.data
      delete data.pagination
      delete data.dataTableColumn
      this.more = data
    },

    processarDados (data) {
      var dataTableValues = []
      for (const item of data) {
        var dataTableItem = this.definirCampo(item)
        var subTable = []
        dataTableItem.data = item

        if (this.subtable) {
          const atributos = this.subtable.field.split('.')
          var subTableData = item

          for (const atributo of atributos) {
            if (atributo.indexOf('[') === -1) {
              if (subTableData[atributo]) {
                subTableData = subTableData[atributo]
              } else {
                subTableData = ''
              }
            } else {
              break
            }
          }

          if (subTableData) {
            dataTableItem.subtable = true
            dataTableItem.toggle = true
            for (const value of subTableData) {
              const subtableItem = this.definirCampoSubTable(value, this.subtable.column)
              subtableItem.data = value
              subTable.push(subtableItem)
            }
            subTable.type = 'subtable'
            subTable.if = false
          }
        }

        dataTableValues.push(dataTableItem)
        if (subTable.length > 0) {
          dataTableValues.push(subTable)
        }
      }

      return dataTableValues
    },

    definirCampoSubTable (item, columns) {
      var dataTableItem = []

      for (const columnName of columns) {
        const column = typeof columnName === 'object' ? columnName.column : columnName
        const converterName = typeof columnName === 'object' ? columnName.converter : undefined
        const setValue = typeof columnName === 'object' ? columnName.$set : undefined

        var dataTableItemCell = {}
        dataTableItemCell = tratarCamposDataTable(item, column, converterName, setValue)
        dataTableItemCell.type = 'subtable'
        dataTableItem.push(dataTableItemCell)
      }

      return dataTableItem
    },

    definirCampo (item) {
      var dataTableItem = []

      for (var i = 0; i < this.column.length; i++) {
        const columnTable = this.column[i]
        const column = typeof columnTable === 'object' ? columnTable.column : columnTable
        const converterName = typeof columnTable === 'object' ? columnTable.converter : undefined

        var dataTableItemCell = {}
        dataTableItemCell = tratarCamposDataTable(item, column, converterName)
        dataTableItem.push(dataTableItemCell)
      }

      dataTableItem.push({
        type: 'table'
      })
      return dataTableItem
    },

    resetDataTableItem () {
      this.$store.commit('MUT_DATA_TABLE_CHECKED', [])
      this.$store.commit('MUT_KEY_TABLE_CHECKED', [])
    },

    actions (actionName) {
      const dictonary = {
        RESET_SELECTED: this.resetDataTableItem
      }

      const action = dictonary[actionName]
      if (action) {
        action()
      }
    }
  },

  created () {
    if (this.renderizarCheckBox) {
      this.$store.commit('MUT_DATA_TABLE_CHECKED', [])
      this.$store.commit('MUT_KEY_TABLE_CHECKED', [])
    }
    eventBus.$on(this.eventBusDataName, (values, outro) => {
      this.actions(outro)
      this.popularTable(values)
      this.keyUpdate = !this.keyUpdate
    })
    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.trocaDePagina(numeroPagina)
      this.keyUpdate = !this.keyUpdate
    })
  },

  destroyed () {
    eventBus.$off(this.eventBusDataName)
    eventBus.$off(this.eventBusPaginationName)
    this.$store.commit('MUT_DATA_TABLE_CHECKED', [])
    this.$store.commit('MUT_KEY_TABLE_CHECKED', [])
  }
}
</script>

<style scoped>
.tableFixed {
    table-layout: fixed;
}

</style>
